import MultiSigWalletAbi from '../../../contracts/MultiSigWallet.abi.js'
import VerificationAbi from './VerificationAbi.js'
import RedemptionAbi from './RedemptionAbi.js'
import RegionalDaoTokenAbi from './RegionalDaoTokenAbi.js'
import RegionalDaoGovernorAbi from '../../../contracts/RegionalDaoGovernor.abi.js'
import TimeLockAbi from '../../../contracts/TimeLock.abi.js'

const ABIS = {
  REGIONAL_DAO: {
    methods: [
      'function propose(address[] memory targets, uint256[] memory values, bytes[] memory calldatas, string memory description)',
      'function castVote(uint256 proposalId, uint8 support)',
      'function castVoteWithReason(uint256 proposalId, uint8 support, string reason) public returns (uint256)',
      'function hasVoted(uint256 proposalId, address account) public view returns (bool)',
      'function state(uint256 proposalId) public view returns (uint8)',
      'function getProposalTotalVote(uint256 proposalId) public view returns (uint256, uint256)',
      'function confirmTransaction(uint256 _txIndex) public returns (uint256)',
      'function token() public view returns (address)',
      'function proposals(uint256 proposalId) public view returns (address proposer, uint256 voteStart, uint256 voteEnd, bool executed, bool canceled)',
      'function hashProposal(address[] memory targets, uint256[] memory values, bytes[] memory calldatas, bytes32 descriptionHash) public pure returns (uint256)',
      'function timelock() public view returns (address)',
    ],
  },
  REGIONAL_DAO_TOKEN: {
    methods: [
      {
        inputs: [
          { internalType: 'uint256', name: 'timepoint', type: 'uint256' },
        ],
        name: 'getPastTotalSupply',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'totalSupply',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'CLOCK_MODE',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'delegates',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'getVotes',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'account', type: 'address' },
          { internalType: 'uint256', name: 'timepoint', type: 'uint256' },
        ],
        name: 'getPastVotes',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'to', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transfer',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'delegatee', type: 'address' },
        ],
        name: 'delegate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
    ],
  },
  REGISTRY: {
    methods: [
      'function storeDaoAction(address regionalDao, address proposer, string memory content)',
      'function grantRole(bytes32 role, address account)',
      'function hasRole(bytes32 role, address account) view returns (bool)',
      'function addDaoMultiSigWallet(address dao, address multiSigWallet)',
      'function getDaoMultiSigWallet(address dao) view returns (address)',
    ],
  },
  REDEMPTION: {
    methods: RedemptionAbi.abi,
  },
  MULTI_SIG: {
    methods: MultiSigWalletAbi,
  },
  REGIONAL_DAO_GOVERNOR: {
    methods: [
      {
        inputs: [
          { internalType: 'uint256', name: 'timepoint', type: 'uint256' },
        ],
        name: 'quorumNumerator',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'uint256', name: 'timepoint', type: 'uint256' },
        ],
        name: 'quorum',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'token',
        outputs: [
          { internalType: 'contract IVotes', name: '', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address[]', name: 'targets', type: 'address[]' },
          { internalType: 'uint256[]', name: 'values', type: 'uint256[]' },
          { internalType: 'bytes[]', name: 'calldatas', type: 'bytes[]' },
          { internalType: 'bytes32', name: 'descriptionHash', type: 'bytes32' },
        ],
        name: 'queue',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address[]', name: 'targets', type: 'address[]' },
          { internalType: 'uint256[]', name: 'values', type: 'uint256[]' },
          { internalType: 'bytes[]', name: 'calldatas', type: 'bytes[]' },
          { internalType: 'bytes32', name: 'descriptionHash', type: 'bytes32' },
        ],
        name: 'execute',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'payable',
        type: 'function',
      },
    ],
  },
  VERIFICATION: {
    methods: VerificationAbi.abi,
  },
  TIMELOCK: {
    methods: TimeLockAbi,
  },
}

/** @param {string} contract - The address of the contract */
export function getContractABI(contract) {
  const polyscanAPIKey = 'X8BUYYT47EW9NK48KG6V7AHU8SG9SQPFB3'
  const url = `https://api.polygonscan.com/api
?module=contract
&action=getabi
&address=${contract}
&apikey=${polyscanAPIKey}`

  const getAbi = async () => {
    try {
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }
      const responseData = await response.json()
      const abi = JSON.parse(responseData.result)
      return abi
    } catch (error) {
      console.error('Error:', error.message)
    }
  }
  const result = getAbi()
  return result
}

export default ABIS
